import user from '@/helper/currentUser';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

function useKnowledgeBaseEnabled(): boolean {
  const { [FeatureFlags.EnableKnowledgeBase]: isFeatureFlagEnabled } = useFeatureFlags();
  const isMasquerading = user.isMasquerading();

  return isFeatureFlagEnabled && !isMasquerading;
}

export default useKnowledgeBaseEnabled;
